import React, { useEffect, useRef, useState } from 'react';
import {useDroppable} from '@dnd-kit/core';
import mergeRefs from 'merge-refs';

export const Droppable = (props) => {
    const { id, children, className, onClick } = props;
    const [isVisible, setIsVisible] = useState(false);
    const targetRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {
                root: null, // viewport
                rootMargin: '0px', // no margin
                threshold: 0.5, // 50% of target visible
            }
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        // Clean up the observer
        return () => {
            if (targetRef.current) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                observer.unobserve(targetRef.current);
            }
        };
    }, []);

    const { setNodeRef, isOver } = useDroppable({
        id,
        disabled: !isVisible,
    });

    return (
        <div ref={mergeRefs(setNodeRef, targetRef)} className={className} onClick={onClick} data-hover={isOver}>
            {children}
        </div>
    );
}